import { EGameKey } from "MVVM/@types";
import { PlaylistClip } from "../@types";
import { gameIdToKey } from "MVVM/Utilities/Game";

export const formatPlaylistClip = (playlistClip: PlaylistClip) => {
  return {
    ...playlistClip,
    id: playlistClip._id,
    user: {
      _id: playlistClip.user,
      avatar: "",
      avatarUrl: "",
      commentsDisabled: false,
      username: playlistClip.username,
    },
    canRequestPortrait: false,
    comments: [],
    createdAt: playlistClip.createdDate,
    developer: { slug: "" },
    effects: [],
    game: gameIdToKey(playlistClip?.game),
    portraitUrl: playlistClip.mobile?.url || "",
    hasPortrait: !!playlistClip.mobile?.url,
    isRemixable: false,
    pointOfView: "OTHER" as const,
    metadata: playlistClip.metadata.map((meta) => ({
      key: String(meta.key || ""),
      value: String(meta.value || ""),
    })),
    score: 0,
    type: "STANDARD" as const,
    useCase: "",
    campaign: {
      isActive: false,
      marketingCopyClip: "",
      marketing: {
        copyClip: null,
        backgroundImage: null,
        brandLogo: null,
      },
      slug: "",
      primaryColor: "",
      secondaryColor: "",
      endsAt: "",
    },
    moment: {
      id: "",
      match: {
        id: "",
        players: [
          {
            accountName: "",
            avatar: "",
            displayName: "",
            user: {
              _id: playlistClip.user,
              avatar: "",
              avatarUrl: "",
              commentsDisabled: false,
              username: playlistClip.username,
            },
            gameId: "",
          },
        ],
      },
    },
    remixOf: {
      user: {
        _id: playlistClip.user,
        avatar: "",
        avatarUrl: "",
        commentsDisabled: false,
        username: playlistClip.username,
      },
    },
  };
};

export const getPlayerPhoto = (clip: {
  metadata: { key: string; value: string }[];
}) =>
  clip?.metadata?.find(
    (metadata: { key: string; value: string }) =>
      metadata.key === "playerPhoto",
  )?.value;

export const getTeamLogo = (clip: {
  metadata: { key: string; value: string }[];
}) =>
  clip?.metadata?.find(
    (clip: { key: string; value: string }) => clip.key === "teamLogo",
  )?.value;

export const getPlayerName = (clip: {
  metadata: { key: string; value: string }[];
}) =>
  clip?.metadata?.find(
    (metadata: { key: string; value: string }) => metadata.key === "playerName",
  )?.value;

export const getMatchType = (clip: {
  metadata: { key: string; value: string }[];
}) =>
  clip?.metadata?.find(
    (metadata: { key: string; value: string }) => metadata.key === "Match Type",
  )?.value;

export enum Partner {
  HLTV = "HLTV",
  UGG = "UGG",
  LEETIFY = "LEETIFY",
  GC = "GC",
  TRN = "TRN",
  OPGG = "OPGG",
}

export const PARTNER_ID: Record<Partner, string[]> = {
  [Partner.HLTV]: ["CROM,INC.", "HLTV.ORG"],
  [Partner.UGG]: ["UDOTGG", "U.GG"],
  [Partner.LEETIFY]: ["L202211"],
  [Partner.GC]: ["GC2022"],
  [Partner.TRN]: ["TRACKERNETWORKLLC"],
  [Partner.OPGG]: ["OP.GG", "OPGG"],
};

export const isPartner = (
  id: string | null | undefined,
  partner: Partner,
): boolean => {
  if (!id) return false;
  return PARTNER_ID[partner].includes(id);
};

export const WATCH_LIMIT_EXCLUDED_PLATFORMS = ["U.GG", "OP.GG", "FACECHECK"];

export const extractQueryParamFromUrl = (
  url: string,
  param: string,
): string | null => {
  try {
    const urlObject = new URL(url);
    return urlObject.searchParams.get(param);
  } catch {
    return null;
  }
};

export const getCountryCode = (): string | null => {
  const lang = navigator.language || "";
  const parts = lang.split("-");
  return parts[1]?.toLowerCase() || null;
};

export const getMetadataValue = (
  metadata: Record<string, unknown>[] | undefined,
  key: string,
): string => {
  return metadata?.find((meta) => meta.key === key)?.value?.toString() || "";
};
